import { createApi } from '@reduxjs/toolkit/query/react'
import { FAVOURITE_PRIVATE_CLIENT, PRIVATE_CLIENT_DETAIL, PRIVATE_CLIENT_LIST, SHARE_LINKS_PRIVATE_CLIENT, PRIVATE_CLIENT_UPDATE } from "config/apiPaths"
import { RTK_CACHE_EXPIRATION } from "config/constants"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const privateClientApi = createApi({
    reducerPath: 'privateClientApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client/private",
    }),
    tagTypes: ["PrivateClientList", "PrivateClientDetails"],
    keepUnusedDataFor: RTK_CACHE_EXPIRATION,
    endpoints: (builder) => ({

        // get private client list
        getPrivateClientList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, funding_source = "", sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: PRIVATE_CLIENT_LIST,
                    data: { search, status: status?.value || "", page, limit, sort, funding_source: funding_source?.value || "" }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["PrivateClientList"]
        }),

        // private client details
        getPrivateClientDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${PRIVATE_CLIENT_DETAIL}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["PrivateClientDetails"]
        }),

        // update client
        updatePrivateClient: builder.mutation({
            query: (data) => ({
                method: "PUT",
                url: `${PRIVATE_CLIENT_UPDATE}/${data.id}`,
                data: data.payload
            }),
            invalidatesTags: ["PrivateClientList", "PrivateClientDetails"]
        }),

        favouritePrivateClient: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_PRIVATE_CLIENT}/${id}`,
                data
            }),
            invalidatesTags: ["PrivateClientList", "PrivateClientDetails"]
        }),

        shareLinksPrivateClient: builder.mutation({
            query: ({ clientId, data }) => ({
                method: "PUT",
                url: `${SHARE_LINKS_PRIVATE_CLIENT}/${clientId}`,
                data
            }),
            invalidatesTags: ["PrivateClientDetails"],
            transformResponse: (response) => response?.data,
        }),
    }),
})

export const {
    useGetPrivateClientDetailsQuery,
    useGetPrivateClientListQuery,
    useLazyGetPrivateClientListQuery,
    useUpdatePrivateClientMutation,
    useFavouritePrivateClientMutation,
    useShareLinksPrivateClientMutation
} = privateClientApi;